<template>
<Box @close="close({})" v-if="pedido_items">
    <template #top>
        Pedido de Compra: {{ pedido_items.pei_id }}
    </template>
    <template #center>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-grid">
                    <Info label="Proyecto">{{ pedido_items.pry_nombre }}</Info>
                    <Info label="Estado">{{ pedido_items.pei_estado_nombre }}</Info>
                    <Info label="Solicitante">{{ pedido_items.usu_solicitante_nombre }}</Info>
                    <Info label="Logistico">{{ pedido_items.usu_logistica_nombre }}</Info>
                    <Info label="Almacen destino">{{ pedido_items.alm_nombre }}</Info>
                    <Info label="Fecha registro">{{ pedido_items.pei_fecha_registro }}</Info>
                </div>
                <div class="nj-grid c1">
                    <Info label="Notas">{{ pedido_items.pei_notas }}</Info>
                </div>
                <br>
                <b-table :data="pedido_items.lista_pedido_items_detalle" style="width: 100%;">
                    <template slot-scope="props">
                        <b-table-column label="ID" header-class="is-info" style="width: 60px;">{{ props.row.prv_id }}</b-table-column>
                        <b-table-column label="Producto" header-class="is-info">{{ props.row.pid_producto }}</b-table-column>
                        <b-table-column label="Cantidad solicitada" header-class="is-info" style="width: 100px;">{{ props.row.pid_cantidad_solicitada }}</b-table-column>
                        <b-table-column label="Cantidad aprobada" header-class="is-info" style="width: 100px;">{{ props.row.pid_cantidad_aprobada }}</b-table-column>
                        <b-table-column label="Cantidad comprada" header-class="is-info" style="width: 100px;">{{ props.row.oci_cantidad }}</b-table-column>
                        <b-table-column label="Orden compra" header-class="is-info" style="width: 220px;">
                            <Button :label="props.row.ord_code" icon="doc" @click="VerOrdenCompra(props.row.ord_id)"></Button>
                        </b-table-column>
                        <b-table-column label="Proveedor" header-class="is-info">{{ props.row.pve_razon_social }}</b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </template>
    <template #bottom>
        <div class="nj-buttons">
            <Button label="Completar" icon="complete" @click="completar()"></Button>
        </div>
    </template>
</Box>
</template>
<script>
import { EmpleadoService, PedidoItemsService, ProductoService, ResponseStatus } from "../../services"
import { Confirm, Data, Tools } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, Info, InputSearch, InputSelect, InputText, InputTextarea } from "../components"
import PedidoItems from "./PedidoItems.vue"
export default {
    name: "VerPedidoItems",
    props: {
        pei_id: null
    },
    components: {
        Box,
        InputText,
        InputTextarea,
        InputSelect,
        Button,
        InputSearch,
        Info,
    },
    data() {
        return {
            pedido_items: {},
        }
    },
    methods: {
        close({
            interfaz = "",
            buscar = false
        }) {
            this.$emit("close", {
                interfaz,
                buscar,
            })
        },
        buscarEmpleados(almacen) {
            EmpleadoService
                .buscar({
                    empleado: {
                        pry_id: almacen.pry_id,
                    }
                })
                .then(response => {
                    this.empleadosLogistica = response.data
                    const request = {
                        empleado: {
                            pry_id: almacen.pry_id,
                        }
                    }
                    EmpleadoService
                        .buscar(request)
                        .then(response => {
                            this.empleadosSolicitante = response.data
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        completar() {
            Confirm.show({
                message: "¿Desea completar el pedido?",
                action: () => {
                    PedidoItemsService
                        .completar({
                            pedido_items: {
                                pei_id: this.pedido_items.pei_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.close({
                                    buscar: true
                                })
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        VerOrdenCompra(ord_id) {
            this.$router.push(`/orden/view/${ord_id}`)
        },
    },
    mounted() {
        PedidoItemsService
            .obtener({
                pedido_items: {
                    pei_id: this.pei_id
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.pedido_items = response.data
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped></style>